import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './dialog';
import { Button } from './button';
import { Label } from './label';
import { Checkbox } from './checkbox';
import { STATUS_TYPES } from '../../features/home/constants/filterConstants';

interface UpdateStatusDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentStatus: string;
  onUpdate: (status: string) => void;
  projectName?: string;
}

const UpdateStatusDialog: React.FC<UpdateStatusDialogProps> = ({
  open,
  onOpenChange,
  currentStatus,
  onUpdate,
  projectName = 'Project'
}) => {
  const [selectedStatus, setSelectedStatus] = useState(currentStatus);
  const [isLoading, setIsLoading] = useState(false);

  const handleUpdate = async () => {
    if (selectedStatus) {
      setIsLoading(true);
      try {
        await onUpdate(selectedStatus);
        onOpenChange(false);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleCancel = () => {
    setSelectedStatus(currentStatus);
    onOpenChange(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !isLoading) {
      e.preventDefault();
      handleUpdate();
    }
  };

  return (
    <Dialog open={open} onOpenChange={(open) => {
      if (!open) {
        handleCancel();
      } 
    }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Update <b style={{ color: "#EF314C" }}> {projectName}</b> Status</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-3">
            <Label>Select Status</Label>
            <div className="space-y-2" onKeyPress={handleKeyPress}>
              {STATUS_TYPES.map((status) => (
                <div key={status} className="flex items-center space-x-2">
                  <Checkbox
                    id={status}
                    checked={selectedStatus === status}
                    onCheckedChange={() => setSelectedStatus(status)}
                    disabled={isLoading}
                  />
                  <Label
                    htmlFor={status}
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
                  >
                    {status}
                  </Label>
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <Button
              variant="outline"
              onClick={handleCancel}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              onClick={handleUpdate}
              className="bg-[#EB1C37] text-white hover:bg-[#EB1C37]/90"
              disabled={!selectedStatus}
              loading={isLoading}
              loadingText="Updating..."
            >
              Update Status
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateStatusDialog; 